// Copyright 2026 UBC Quantum Software and Algorithms Research Lab

// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at

//     http://www.apache.org/licenses/LICENSE-2.0

// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { memo } from "react";

const MeasurementBadge = ({ data }) => {
    if (!data.mid_measurement_index) return null;
    return (
        <div style={{
            position: "absolute", top: "-10px", right: "-10px", width: "32px", height: "32px",
            background: "#e48f27ff", color: "#ffffffff", borderRadius: "50%", display: "flex",
            alignItems: "center", justifyContent: "center", fontWeight: "bold", fontSize: "16px",
            boxShadow: "0 2px 4px #fbc66fff", zIndex: 30, border: "1px solid #fbc66fff"
        }}>
            {data.mid_measurement_index}
        </div>
    );
};

export default memo(MeasurementBadge);
